import { Reveal, Stagger, StaggerItem, fadeInUp, fadeInLeft, fadeInRight } from './motion';
import { RAG, useLang, pick } from './content';

export function HybridRagExplainer() {
  const lang = useLang();
  const laneVariants = [fadeInLeft, fadeInUp, fadeInRight];
  return (
    <section className="border-t border-ink-100 bg-paper-50/40">
      <div className="mx-auto max-w-6xl px-5 sm:px-6 py-16 md:py-20">
        <Reveal>
          <div className="max-w-3xl">
            <div className="text-[12px] uppercase tracking-[0.18em] text-accent-600 font-semibold">{pick(RAG.eyebrow, lang)}</div>
            <h2 className="mt-2 display serif-jp text-3xl md:text-4xl font-semibold tracking-tight text-ink-900 text-balance">
              {pick(RAG.h2, lang)}
            </h2>
          </div>
        </Reveal>

        <Stagger stagger={0.1} className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-3">
          {RAG.lanes.map((lane, i) => (
            <StaggerItem key={lane.name} variant={laneVariants[i]}>
              <div className="card-paper p-5 h-full">
                <div className="text-[11px] uppercase tracking-[0.14em] text-citation-600 font-semibold">{pick(lane.name, lang)}</div>
                <p className="mt-2 text-[13.5px] text-ink-600 leading-relaxed">{pick(lane.body, lang)}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>

        <Reveal delay={0.15}>
          <div className="mt-3 flex flex-col items-center">
            <div className="text-ink-300 text-xl leading-none">↓</div>
            <div className="rounded-full bg-accent-50 text-accent-700 text-[12.5px] font-medium px-4 py-1.5 border border-accent-100">
              {pick(RAG.fusion, lang)}
            </div>
            <div className="text-ink-300 text-xl leading-none mt-1">↓</div>
          </div>
        </Reveal>

        <Reveal variant={fadeInUp} delay={0.1}>
          <div className="mt-2 card-paper p-5 max-w-3xl mx-auto">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
              {RAG.citationFields.map((f) => (
                <div key={f} className="rounded-lg bg-paper-50 border border-ink-100 px-3 py-2 text-center">
                  <span className="text-[11.5px] text-ink-700">{pick(f, lang)}</span>
                </div>
              ))}
            </div>
            <p className="mt-4 text-center text-[14px] text-ink-700 leading-relaxed">{pick(RAG.tagline, lang)}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
